import { useEffect, useState } from 'react'
import type { Font } from '../../domain/canvas/value-objects/font'
import { FontListSchema } from '../../domain/canvas/value-objects/font'

const FONTS_URL = '/api/fonts'
// Fallback fonts if CDN is not accessible
// const FALLBACK_FONTS: Font[] = [
//   { name: 'Arial', font: '' },
//   { name: 'Helvetica', font: '' },
//   { name: 'Times New Roman', font: '' },
//   { name: 'Georgia', font: '' },
//   { name: 'Verdana', font: '' },
// ]

/**
 * Hook to fetch and cache fonts from CDN
 * @param filter - Optional array of font names to filter by
 * @returns Array of fonts or undefined if loading
 */
export const useQueryFonts = (filter?: string[]): Font[] | undefined => {
  const [fonts, setFonts] = useState<Font[] | undefined>()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchFonts = async () => {
      try {
        // Fetch from CDN
        console.log('Fetching fonts from:', FONTS_URL)
        const response = await fetch(FONTS_URL, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        })
        if (!response.ok) {
          throw new Error(`Failed to fetch fonts: ${response.status} ${response.statusText}`)
        }

        const data = await response.json()
        const validatedFonts = FontListSchema.parse(data)
        setFonts(validatedFonts)
      } catch (err) {
        console.error('Error fetching fonts:', err)
        // Set empty array on error to avoid undefined
        setFonts([])
      } finally {
        setLoading(false)
      }
    }

    fetchFonts()
  }, [])

  // Apply filter if provided
  const filteredFonts = fonts
    ? filter
      ? fonts.filter((font) => filter.includes(font.name))
      : fonts
    : undefined

  return loading ? undefined : filteredFonts
}
